import { render, staticRenderFns } from "./CustomerStaffOperator.vue?vue&type=template&id=4691d71c&scoped=true&"
import script from "./CustomerStaffOperator.vue?vue&type=script&lang=js&"
export * from "./CustomerStaffOperator.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStaffOperator.vue?vue&type=style&index=0&id=4691d71c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691d71c",
  null
  
)

export default component.exports